import { FloatingWindow } from '@/shared/ui/FloatingWindow';
import type { ReportWindowType } from '@/shared/lib/windows';
import {
  DebtsReportPage,
  ExpiryReportPage,
  NegativeStockReportPage,
  ProfitReportPage,
  ProvisionalSalesReportPage,
  SalesReportPage,
  StockReportPage,
  TurnoverReportPage,
  WriteOffsReportPage,
} from '@/features/reports';

const REPORT_LABELS: Record<ReportWindowType, string> = {
  stock: 'Остатки',
  turnover: 'Обороты',
  sales: 'Продажи',
  profit: 'Прибыль',
  'write-offs': 'Списания',
  debts: 'Долги',
  expiry: 'Сроки годности',
  'negative-stock': 'Товары в минусе',
  'provisional-sales': 'Предварительная себестоимость',
};

export interface ReportWindowProps {
  report: ReportWindowType;
  onClose: () => void;
}

/** §13, §1.8: каждый отчёт — своё плавающее окно (как документы/оплаты, §11.1): можно открыть
 *  сразу несколько разных отчётов, каждый двигается и запоминает размер/позицию независимо. */
export function ReportWindow({ report, onClose }: ReportWindowProps) {
  const content = (() => {
    switch (report) {
      case 'stock':
        return <StockReportPage />;
      case 'turnover':
        return <TurnoverReportPage />;
      case 'sales':
        return <SalesReportPage />;
      case 'profit':
        return <ProfitReportPage />;
      case 'write-offs':
        return <WriteOffsReportPage />;
      case 'debts':
        return <DebtsReportPage />;
      case 'expiry':
        return <ExpiryReportPage />;
      case 'negative-stock':
        return <NegativeStockReportPage />;
      case 'provisional-sales':
        return <ProvisionalSalesReportPage />;
    }
  })();

  return (
    <FloatingWindow kind={`report:${report}`} title={REPORT_LABELS[report]} onClose={onClose}>
      {content}
    </FloatingWindow>
  );
}
